import { render } from "./barTypeDetails.vue?vue&type=template&id=2d5d5686&scoped=true"
import script from "./barTypeDetails.vue?vue&type=script&lang=js"
export * from "./barTypeDetails.vue?vue&type=script&lang=js"

import "./barTypeDetails.vue?vue&type=style&index=0&id=2d5d5686&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5d5686"]])

export default __exports__